import { render, staticRenderFns } from "./dr-chart-canvas.vue?vue&type=template&id=547e1164&"
import script from "./dr-chart-canvas.vue?vue&type=script&lang=js&"
export * from "./dr-chart-canvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports